import apiClient from '@app/config/axios.config'
import { Endpoint } from '@app/config/endpoints'
import {
  FeatureFlagManageResponse,
  UpdateFeatureFlagRolesRequest,
  UpdateFeatureFlagRolesResponse,
} from '@app/types'
import { logger } from '@app/utils/logger'

const FeatureFlagService = {
  getFeatureFlagRoles: async (): Promise<FeatureFlagManageResponse> => {
    try {
      const response = await apiClient.get<FeatureFlagManageResponse>(Endpoint.manageFeatureFlags)
      return response.data
    } catch (error) {
      logger.error('Error fetching feature flag roles:', error)
      throw error
    }
  },

  updateFeatureFlagRoles: async (
    featureFlag: UpdateFeatureFlagRolesRequest,
  ): Promise<UpdateFeatureFlagRolesResponse> => {
    try {
      const { feature, user_roles } = featureFlag
      const response = await apiClient.put<{ user_roles: string[] }>(
        `${Endpoint.manageFeatureFlags}/${feature}`,
        { user_roles },
      )
      // API returns only {user_roles}, so add the feature back
      return {
        feature,
        user_roles: response.data.user_roles,
      }
    } catch (error) {
      logger.error('Error updating feature flag roles:', error)
      throw error
    }
  },
}

export { FeatureFlagService }
